import React, { useEffect, useState } from "react";
import { CommonButton } from "./CommonButton";
import FeaturesIcon from "assets/svgIcons/AdminSubSideNav/FeaturesIcon";
import SiteSettingIcon from "assets/svgIcons/AdminSubSideNav/SiteSettingIcon";
import UsersIcon from "assets/svgIcons/AdminSubSideNav/UsersIcon";
import ValidationIcon from "assets/svgIcons/AdminSubSideNav/ValidationIcon";
import MVIcon from "assets/svgIcons/AdminSubSideNav/MVIcon";
import { CommonHeading } from "./CommonHeading";
import { useHookstate } from "@hookstate/core";
import {
  MAP_GLOBAL_STATES,
} from "globalStore/globalStore";
import { SubSideNavTabs } from "commonComponents/SideNav/subSideNav/subSideNavStyled";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
export const AdminSideNav = () => {
  const { t } = useTranslation();
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  const [showComponent, setShowComponent] = useState(true);
  
  useEffect(() => {
    let getSubnavName = localStorage.getItem("mapSideNavTabState");
    if (
      getSubnavName === "Features" ||
      getSubnavName === "Site Settings" ||
      getSubnavName === "Users" ||
      getSubnavName === "Validations" ||
      getSubnavName === "Manifest Viewer"
    ) {
      mapSideNavTabState.set(localStorage.getItem("mapSideNavTabState"));
    } else {
      mapSideNavTabState.set("Features");
      localStorage.setItem("mapSideNavTabState","Features")
    }
    // setInterval(() => {
    //   setShowComponent(!showComponent);
    // }, 10000);
  }, []);

  return (
    <div>
        <div>
          <CommonHeading labelText={"Admin"} />
          <SubSideNavTabs className="web-only-admin-side-nav">
            <Tooltip title={t("Features")}>
              <span>
                <CommonButton
                  labelText={"Features"}
                  displayText={"Features"}
                  changeSideNavData={() => {
                    localStorage.setItem("mapSideNavTabState", "Features");
                    mapSideNavTabState.set("Features");
                  }}
                >
                  <FeaturesIcon
                    color={
                      mapSideNavTabState.get() === "Features"
                        ? "var(--theme-text)"
                        : "var(--text-secondary)"
                    }
                  />
                </CommonButton>
              </span>
            </Tooltip>

            <Tooltip title={t("Site_Settings")}>
              <span className="Scorecards">
                <CommonButton
                  labelText="Site Settings"
                  displayText="Site_Settings"
                  changeSideNavData={() => {
                    localStorage.setItem("mapSideNavTabState", "Site Settings");
                    mapSideNavTabState.set("Site Settings");
                  }}
                >
                  <SiteSettingIcon
                    color={
                      mapSideNavTabState.get() === "Site Settings"
                        ? "var(--theme-text)"
                        : "var(--text-secondary)"
                    }
                  />
                </CommonButton>
              </span>
            </Tooltip>

            <Tooltip title={t("Users")}>
              <span className="Scorecards">
                <CommonButton
                  labelText="Users"
                  displayText="Users"
                  changeSideNavData={() => {
                    localStorage.setItem("mapSideNavTabState", "Users");
                    mapSideNavTabState.set("Users");
                  }}
                >
                  <UsersIcon
                    color={
                      mapSideNavTabState.get() === "Users"
                        ? "var(--theme-text)"
                        : "var(--text-secondary)"
                    }
                  />
                </CommonButton>
              </span>
            </Tooltip>

            <Tooltip title={t("Validations")}>
              <span className="Scorecards">
                <CommonButton
                  labelText="Validations"
                  displayText="Validations"
                  changeSideNavData={() => {
                    localStorage.setItem("mapSideNavTabState", "Validations");
                    mapSideNavTabState.set("Validations");
                  }}
                >
                  <ValidationIcon
                    color={
                      mapSideNavTabState.get() === "Validations"
                        ? "var(--theme-text)"
                        : "var(--text-secondary)"
                    }
                  />
                </CommonButton>
              </span>
            </Tooltip>

            <Tooltip title={t("Manifest_Viewer")}>
              <span className="Scorecards">
                <CommonButton
                  labelText="Manifest Viewer"
                  displayText="Manifest_Viewer"
                  changeSideNavData={() => {
                    localStorage.setItem("mapSideNavTabState", "Manifest Viewer");
                    mapSideNavTabState.set("Manifest Viewer");
                  }}
                >
                  <MVIcon
                    color={
                      mapSideNavTabState.get() === "Manifest Viewer"
                        ? "var(--theme-text)"
                        : "var(--text-secondary)"
                    }
                  />
                </CommonButton>
              </span>
            </Tooltip>
          </SubSideNavTabs>
        </div>
    </div>
  );
};
